import { createGlobalStyle } from "styled-components";
const HeaderStyle = createGlobalStyle`

    .header-wrap{
        .heading{
            margin-bottom: 0;
        }

        p + p {
            margin-top : 0px;
        }
        
        .form-button{
            color: #000;
            box-sizing: border-box;
            border-radius: 24px;
            width: 184px;
            height: 40px;
            transition: all 0.25s linear 0s;
            font-weight: 700;
            border: none;
        }
        
        .search-bar{
            width: 347px;
            height: 40px;
            border-radius: 24px;
            background: #3C3C3C;
            background-repeat: no-repeat;
            background-position: left;
            background-position-y: center;
            background-position-x: 10px;
            border: none;
            padding: 0 40px;
            padding-right: 20px;
            color:  #FFFFFF;
            border: 1px solid #3c3c3c;
            :focus{
                outline : none;
            }
            
            ::placeholder
            {   
                color: #A0A0A0;
                font-size: 16px;
            }
        }
    }
`;

export default HeaderStyle